import { SELECT_EDIT_MAP_POINT } from './types';

export const selectPointEditMap = selectedDataPoint => ({
  type: SELECT_EDIT_MAP_POINT,
  selectedDataPoint,
});
